import { InputWithAddon } from '../InputWithAddon'
import { NumberInputBase, NumberInputBaseProps } from '../NumberInputBase'
import { PlusMinus } from '../PlusMinus'
import { ButtonsContainer } from './styles'

interface NumberInputProps extends NumberInputBaseProps {
  value: number | string
  onChange: any
  min?: number
  max?: number
  disabled?: boolean
}

export const NumberInput = ({
  value,
  onChange,
  min,
  max,
  disabled,
  ...rest
}: NumberInputProps) => (
  <InputWithAddon
    addonAfter={() =>
      disabled ? null : (
        <ButtonsContainer>
          <PlusMinus max={max} min={min} onChange={onChange} value={value} />
        </ButtonsContainer>
      )
    }
    disabled={disabled}
    inputComponent={NumberInputBase}
    onChange={onChange}
    value={value}
    {...rest}
  />
)
